import { types } from 'mobx-state-tree'
import { notifications } from '../api'
import object_value from '../api/object_value'
import { simple_api_request } from '../api/simple_api_request'

const NotificationsStore = types.model({
  loaded: types.optional(types.boolean, false),
  data: types.optional(types.frozen, [])
})
.views(
  /**
   * @param {Object} self
   * @returns {Object}
   */
  self => ({
      get has_unread_notification () {
        if (!self.loaded) {
          return false
        }

        const notifications = object_value(self, 'data')

        if (!Array.isArray(notifications) || notifications.length < 1) {
          return false
        }

        for (let notification of notifications) {
          if (!notification.read) {
            return true
          }
        }
      }
    }
  )
)
.actions(
  /**
   * @param {Object} self
   * @returns {Object}
   */
  self => ({
    get (token) {
      notifications(token).then(
        self.fetch
      )
    },
    fetch (data) {
      if (data) {
        self.data = data
        self.loaded = true
      }
    },
    clean () {
      self.data = null
      self.loaded = false
    },
    mark_as_read (token, notification_id) {
      self.status = 'loading'

      simple_api_request({
        method: 'PATCH',
        path: '/api/notifications/' + notification_id + '/read',
        header_token: token
      }).then(
        self.process_response
      )
    },
    process_response (result) {
      console.log('NotificationsStore - process_response() - result:', result)

      if (result.ok) {
        self.status = 'success'
      } else {
        let message = result.data.message
        let errors = object_value(result, 'data.errors', {})
        if (errors !== null && typeof errors === 'object') {
          for (let [key, value] of Object.entries(errors)) {
            if (value.length > 0) {
              let fetch_text = ''

              value.forEach(t => {
                fetch_text = fetch_text + t + '<br>'
              })

              message = message + `<br><strong>${key}</strong>:<br>${fetch_text}`
            }
          }
        }

        self.status = 'error'
        self.status_message = message
      }
    }
  })
)

export default NotificationsStore



// WEBPACK FOOTER //
// ./src/stores/NotificationsStore.js